<div class="relative">
  <button
    mat-icon-button
    mat-dialog-close
    color="primary"
    aria-label="Close icon"
    class="absolute top-0 right-0 scale-125"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
<img
  alt="Add blacklist item icon"
  src="../../../assets/figures/man-positive.svg"
  class="h-[88px] mb-6 mx-auto"
/>
<span mat-dialog-title class="text-3xl font-bold text-center"
  >Admin hozzáadása</span
>
<form
  [formGroup]="addAdminFormGroup"
  (ngSubmit)="onSubmit()"
  class="flex flex-col justify-between"
>
  <div class="flex justify-between items-center gap-x-6 px-4">
    <mat-form-field
      appearance="standard"
      class="basis-0 grow"
      hideRequiredMarker
    >
      <mat-label>Email</mat-label>
      <input
        matInput
        formControlName="email"
        type="email"
        autocomplete="email"
      />
      <mat-error
        *ngIf="
          addAdminFormGroup.get('email')?.hasError('email') &&
          !addAdminFormGroup.get('email')?.hasError('required')
        "
      >
        Az email cím formátuma nem megfelelő
      </mat-error>
      <mat-error *ngIf="addAdminFormGroup.get('email')?.hasError('required')">
        Kötelező mező
      </mat-error>
    </mat-form-field>

    <mat-form-field
      appearance="standard"
      class="basis-0 grow"
      hideRequiredMarker
    >
      <mat-label>Név</mat-label>
      <input matInput formControlName="name" autocomplete="name" />
      <mat-error *ngIf="addAdminFormGroup.get('name')?.hasError('required')">
        Kötelező mező
      </mat-error>
    </mat-form-field>
  </div>

  <div class="flex justify-between items-center gap-x-6 px-4 mb-6">
    <mat-form-field
      appearance="standard"
      class="basis-0 grow"
      hideRequiredMarker
    >
      <mat-label>Jelszó</mat-label>
      <input
        matInput
        formControlName="password"
        [type]="passwordVisible ? 'text' : 'password'"
        autocomplete="new-password"
      />
      <mat-icon
        matSuffix
        (click)="togglePasswordVisible()"
        class="material-icons-outlined translate-y-2"
      >
        {{ passwordVisible ? "visibility" : "visibility_off" }}
      </mat-icon>
      <mat-error
        *ngIf="addAdminFormGroup.get('password')?.hasError('required')"
      >
        Kötelező mező
      </mat-error>
      <mat-error *ngIf="addAdminFormGroup.get('password')?.hasError('pattern')">
        A jelszónak tartalmaznia kell kisbetűt, nagybetűt és legalább 1 számot
      </mat-error>
    </mat-form-field>

    <mat-form-field
      appearance="standard"
      class="basis-0 grow"
      hideRequiredMarker
    >
      <mat-label>Hozzáadás dátuma</mat-label>
      <input matInput formControlName="createdAt" autocomplete="off" />
    </mat-form-field>
  </div>

  <app-admin-permissions-checkbox-group
    formControlName="permissions"
  ></app-admin-permissions-checkbox-group>

  <div mat-dialog-actions class="flex justify-between gap-x-4 p-0 mb-0 mt-10">
    <button
      mat-stroked-button
      mat-dialog-close
      color="primary"
      type="button"
      class="mol-btn-lg mol-btn-stroked-primary basis-0 grow"
    >
      Mégsem
    </button>
    <button
      mat-flat-button
      color="primary"
      type="submit"
      class="mol-btn-lg basis-0 grow ml-0"
    >
      Hozzáadás
    </button>
  </div>
</form>
